module.exports = __webpack_public_path__ + "media/images/players/WESTWOOD_LEE-9c25f8a8fb29532b84ca11d2bcb3e08b.png";